module.exports = __webpack_public_path__ + "wow.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/components/editor/styled/wow.png
// module id = 2126
// module chunks = 0